import { find, get, isUndefined } from 'lodash'

import { follow, getFollowingBlacklist, getSelector, unfollow } from 'common/follow-college-service'
import metadataToTrackedEvent from 'common/metadata-to-tracked-event'

import { fetchProspects } from './fetch-prospects'
import types from './types'

export const toggleFollow_Follow = (dispatch, scid, metadata) => {
  const fetchProspectsAction = fetchProspects()
  const followMetadata = metadataToTrackedEvent(metadata, 'Follow', { flat: true })
  const eventData = {
    ...followMetadata,
    scid: scid,
  }
  return follow(scid, eventData)
    .then(() => {
      fetchProspectsAction(dispatch)
      dispatch({ type: types.TOGGLE_FOLLOW_SUCCESS })
    })
    .catch(() => {
      dispatch({ type: types.TOGGLE_FOLLOW_FAILURE })
    })
}

export const toggleFollow_Unfollow = (dispatch, scid, groups, metadata) => {
  const fetchProspectsAction = fetchProspects()
  const unfollowMetadata = metadataToTrackedEvent(metadata, 'Dismissed College', { flat: true })
  const eventData = {
    ...unfollowMetadata,
    scid: scid,
  }

  return unfollow(scid, groups, eventData)
    .then(() => {
      fetchProspectsAction(dispatch)
      dispatch({ type: types.TOGGLE_FOLLOW_SUCCESS })
    })
    .catch(() => {
      dispatch({ type: types.TOGGLE_FOLLOW_FAILURE })
    })
}

export const getCanFollow = (scid, groups) => {
  const blacklist = getFollowingBlacklist(groups)
  const stringScid = scid.toString()
  return isUndefined(get(blacklist, `following['${stringScid}']`))
}

export const getCanUnfollow = (scid, groups) => {
  return !isUndefined(find(get(groups, 'following'), getSelector(scid)))
}

export const toggleFollow = (scid, groups, metadata) => (dispatch) => {
  dispatch({ type: types.TOGGLE_FOLLOW_START })
  if (getCanUnfollow(scid, groups)) {
    return toggleFollow_Unfollow(dispatch, scid, groups, metadata)
  }

  if (getCanFollow(scid, groups)) {
    return toggleFollow_Follow(dispatch, scid, metadata)
  }

  return Promise.reject(dispatch({ type: types.TOGGLE_FOLLOW_FAILURE }))
}
